export default {
      id: "hat-star2-usage",
      viewBox: "0 0 640 384",
      url: "../../assets/" + "sprite.svg#hat-star2-usage",
      toString: function () {
        return this.url;
      }
    }